import { createContext, type ReactNode, useContext } from 'react'
import { createPortal } from 'react-dom'

/** Optional native destinations keep session controls in their original context. */
export const DesktopSessionChrome = createContext<{
  toolbar: HTMLDivElement | null
  sidebar: HTMLDivElement | null
  setSidebar: (element: HTMLDivElement | null) => void
} | null>(null)

export function DesktopSessionIdentitySlot() {
  const chrome = useContext(DesktopSessionChrome)
  return chrome ? (
    <div className="desktop-session-identity" ref={chrome.setSidebar} />
  ) : null
}

export function SessionHeading({
  identity,
  children,
}: {
  identity: ReactNode
  children: ReactNode
}) {
  const chrome = useContext(DesktopSessionChrome)
  if (chrome)
    return (
      <>
        {chrome.sidebar && createPortal(identity, chrome.sidebar)}
        {chrome.toolbar && createPortal(children, chrome.toolbar)}
      </>
    )
  return (
    <header className="session-heading">
      {identity}
      {children}
    </header>
  )
}
